export enum NodeDirection {
    Start,
    End
}